import { render, staticRenderFns } from "./ExamsListItem.vue?vue&type=template&id=5472ad4d&scoped=true&"
import script from "./ExamsListItem.vue?vue&type=script&lang=js&"
export * from "./ExamsListItem.vue?vue&type=script&lang=js&"
import style0 from "./ExamsListItem.vue?vue&type=style&index=0&id=5472ad4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5472ad4d",
  null
  
)

export default component.exports